export { default } from "./product-card";